const tr = {
  common: {
    altLogo: "SamperLabs",
  },
  nav: {
    platform: "Platform",
    carnitrack: "CarniTrack",
    agritrack: "AgriTrack",
    vision: "Vizyon",
    contact: "İletişim",
    demo: "Demo Talep Et",
    ariaCloseMenu: "Menüyü kapat",
    ariaOpenMenu: "Menüyü aç",
    ariaSiteNav: "Site gezintisi",
    langEn: "İngilizce",
    langTr: "Türkçe",
  },
  hero: {
    headlineTr: "için işleme altyapısı yazılımı",
    softwareFor: "Software for",
    processingLine: "İşleme",
    infrastructureLine: "altyapısı",
    processingInfrastructure: "İşleme altyapısı",
    invisibleSpacer: "Hayvancılık",
    subtitle:
      "SamperLabs, kesimhane operasyonlarını gerçek zamanlı izleme, verim verileri ve operasyonel zekâ ile güçlendiriyor — bağlı bir protein tedarik zincirinin temelini oluşturuyor.",
    requestDemo: "Demo Talep Et",
    words: ["Et", "Protein", "Hayvancılık"],
  },
  dashboard: {
    urlHost: "carnitrack.samperlabs.com",
    sidebarOverview: "Genel bakış",
    sidebarIntake: "Kabul",
    sidebarProcessing: "İşleme",
    sidebarYield: "Verim",
    sidebarReports: "Raporlar",
    statIntake: "Kabul",
    statProcessing: "İşleme",
    statYield: "Verim",
    statRate: "Hız",
    statChangeActive: "Aktif",
    statChangeOnTarget: "Hedefte",
    yieldTrend: "Verim eğilimi",
    processingQueue: "İşleme kuyruğu",
    queueWeighing: "Tartım",
    queueProcessing: "İşleme",
    queuePending: "Beklemede",
  },
  problem: {
    label: "Sorun",
    title: "Parçalanmışlık Üzerine Kurulu Bir Sektör",
    body:
      "Et işleme endüstrisi verimsizliğe, izlenebilirliğin azalmasına ve masada kalan değere yol açan eski sistemlerle çalışıyor.",
    items: {
      paper: {
        title: "Kağıt Tabanlı Operasyonlar",
        description:
          "Kesimhaneler kritik operasyonlar için elektronik tablolar, kağıt kayıtları ve birbirinden kopuk sistemlere güveniyor.",
      },
      tracking: {
        title: "Standart İzleme Yok",
        description:
          "Hayvanların kabulden çıktıya kadar işleme hattında izlenmesi için standart bir yöntem yok.",
      },
      visibility: {
        title: "Sınırlı Görünürlük",
        description:
          "Verim performansı, operasyonel verimlilik ve işleme darboğazları hakkında minimal içgörü.",
      },
      supply: {
        title: "Kopuk Tedarik Zinciri",
        description: "Üretici ile işleyici arasında bağlantı olmaması veri adacıkları yaratıyor.",
      },
    },
  },
  platform: {
    label: "Platform",
    title: "İşleme Operasyonları İçin Tek Sistem",
    body:
      "SamperLabs, kesimhane iş akışlarını yönetmek, izlemek ve analiz etmek için birleşik bir platform sunar — parçalı araçların yerine entegre zekâ koyar.",
    features: {
      tracking: {
        title: "Uçtan Uca İzleme",
        desc: "Hayvanları kabulden her işleme aşamasına kadar izleyin",
      },
      realtime: {
        title: "Gerçek Zamanlı Veri",
        desc: "Canlı operasyon metrikleri ve anında görünürlük",
      },
      logs: {
        title: "Yapılandırılmış Kayıtlar",
        desc: "Kapsamlı işleme kayıtları ve denetim izleri",
      },
      analytics: {
        title: "Verim Analitiği",
        desc: "Karkas verimi ve performans hakkında derin içgörüler",
      },
    },
    metricProcessed: "İşlenen",
    metricYieldRate: "Verim oranı",
    metricProcessTime: "İşlem süresi",
    metricDataPoints: "Veri noktası",
    suffixPerMo: "/ay",
    suffixPercent: "%",
    suffixMin: "dk",
    suffixK: "K",
  },
  carnitrack: {
    badge: "Temel ürün",
    title: "CarniTrack",
    tagline: "İşleme zekâsı",
    visit: "CarniTrack’i ziyaret et",
    features: {
      intake: {
        title: "Kabul ve kayıt",
        desc: "Otomatik kimlik ataması ve veri yakalama ile kolaylaştırılmış hayvan kabulü",
      },
      weight: {
        title: "Ağırlık izleme",
        desc: "Her aşamada hassas tartım ve trend analizi",
      },
      stages: {
        title: "İşleme aşamaları",
        desc: "Her işlem adımında ilerlemeyi gerçek zamanlı izleyin",
      },
      yield: {
        title: "Verim analizi",
        desc: "Karkas verimi hesaplamaları ve performans kıyaslaması",
      },
      compliance: {
        title: "Uyumluluk kayıtları",
        desc: "Düzenleyici uyumluluk için otomatik denetim izleri",
      },
      history: {
        title: "Geçmiş veriler",
        desc: "Tam işleme geçmişi ve trend raporlama",
      },
    },
    yieldDistribution: "Verim dağılımı",
    gradePrime: "Prime",
    gradeChoice: "Choice",
    gradeSelect: "Select",
    weeklyThroughput: "Haftalık işlem hacmi",
    dayMon: "Pzt",
    daySun: "Paz",
    performanceScore: "Performans skoru",
  },
  agritrack: {
    badge: "Sırada",
    title: "AgriTrack ile yukarı akışa uzanım",
    body:
      "SamperLabs işlemeyi aşarak hayvancılık üreticilerini bağlar; çiftlikten tesise kesintisiz bir veri hattı oluşturur.",
    bullets: {
      b1: "Çiftlik düzeyinde hayvan bazlı izleme",
      b2: "Zaman içinde ağırlık ve büyüme izleme",
      b3: "İşlemeye kesintisiz veri sürekliliği",
      b4: "Üretici-işleyici veri paylaşımı",
    },
    visit: "AgriTrack’i ziyaret et",
    cardTitle: "AgriTrack",
    cardSubtitle: "Entegre uzantı",
    flowLabel: "Çiftlik → İşleme",
    dataContinuity: "Veri sürekliliği",
    traceability: "İzlenebilirlik",
    statusConnected: "BAĞLI",
    statusEndToEnd: "UÇTAN UCA",
  },
  why: {
    label: "Neden SamperLabs",
    title: "Gerçek operasyonlar için tasarlandı",
    reasons: {
      workflows: {
        title: "Kesimhane iş akışları için",
        description:
          "İhtiyaçlarınıza uyarlanmış jenerik yazılım değil — et işleme operasyonları için baştan inşa edilmiş.",
      },
      accuracy: {
        title: "Yüksek veri doğruluğu",
        description:
          "Düzenleyici gereksinimleri ve iç kalite standartlarını karşılayan hassas izleme ve izlenebilirlik.",
      },
      scale: {
        title: "Ölçeklenebilir altyapı",
        description: "Tek tesisten çok lokasyonlu kuruluşlara kadar — platform sizinle büyür.",
      },
      integration: {
        title: "Entegrasyon için hazır",
        description: "Tartılar, RFID sistemleri ve gelecekteki bilgisayarlı görü ile bağlantıya hazır.",
      },
    },
  },
  vision: {
    label: "Vizyonumuz",
    title: "Protein tedarik zincirinin geleceği",
    body:
      "SamperLabs et üretimi için işletim sistemi inşa ediyor — çiftlikten sofraya her aşamayı zekâ ve şeffaflıkla bağlıyor.",
    points: {
      connected: {
        title: "Bağlı çiftlikler ve işleyiciler",
        desc: "Tedarik zinciri boyunca kesintisiz veri akışı",
      },
      realtime: {
        title: "Gerçek zamanlı görünürlük",
        desc: "Canlı tedarik zinciri izleme ve izleme",
      },
      predictive: {
        title: "Tahmine dayalı analitik",
        desc: "Yapay zekâ destekli optimizasyon ve öngörü",
      },
      transaction: {
        title: "İşlem katmanı",
        desc: "Gelecekteki pazar yeri ve ticaret yetenekleri",
      },
    },
  },
  cta: {
    title: "Daha akıllı bir işleme operasyonu kurun",
    body: "İş akışınızı dijitalleştirmeye başlayın ve gerçek operasyonel içgörüye ulaşın.",
    requestDemo: "Demo Talep Et",
    contactSales: "Satışla iletişim",
  },
  footer: {
    about: "Hakkında",
    contact: "İletişim",
    ariaNav: "Alt bilgi bağlantıları",
    slaughterhouseSoftware: "Kesimhane yazılımı",
    livestockManagement: "Hayvancılık yönetimi",
    proteinSupplyChain: "Protein tedarik zinciri",
    copyright: "© {{year}} SamperLabs",
  },
  seo: {
    home: {
      title: "Kesimhane Yazılımı ve Hayvansal İzleme | SamperLabs",
      description:
        "SamperLabs; kesimhane yazılımı, hayvancılık yönetimi ve protein tedarik zinciri görünürlüğü sunar — çiftlikten işlemeye gerçek zamanlı izleme, verim analitiği ve operasyonel zekâ.",
    },
  },
  faq: {
    title: "Sık sorulan sorular",
    items: [
      {
        q: "Kesimhane yönetim yazılımı nedir?",
        a: "Kesimhane yönetim yazılımı; kabul, işleme aşamaları, tartımlar ve verimi dijitalleştirerek kağıt ve e-tabloların yerine tek bir sistem koyar. İzlenebilirliği artırır, raporlamayı hızlandırır ve yöneticilere kapasite ve performansa canlı görünürlük sağlar.",
      },
      {
        q: "Hayvan izleme işlemeyle nasıl bağlanır?",
        a: "Hayvan izleme, kabulde tanımlamadan başlayarak her üretim adımını takip eder. Üretici sistemleriyle bağlandığında aynı tanımlayıcılar yukarı akışa taşınır; işleyici ve çiftlikler kopuk kayıtlar yerine tutarlı kayıtlar paylaşır.",
      },
      {
        q: "Protein tedarik zinciri platformu nedir?",
        a: "Protein tedarik zinciri platformu; çiftlik, lojistik ve işleme boyunca veriyi birleştirerek paydaşlara hareket, kalite sinyalleri ve operasyon metriklerini tek yerde gösterir. SamperLabs işleme çekirdeğine odaklanır ve entegre ürünlerle yukarı akış görünürlüğünü genişletir.",
      },
      {
        q: "SamperLabs kimin için?",
        a: "SamperLabs; güvenilir veri, denetime uygun kayıtlar ve özel altyapı kurmadan analitik isteyen et işleme ekipleri, tesis müdürleri ve üst yönetim için tasarlandı. CarniTrack tesisi hedefler; AgriTrack hayvancılık üreticilerine görünürlük sunar.",
      },
      {
        q: "CarniTrack genel ERP veya MES araçlarından nasıl farklıdır?",
        a: "CarniTrack kesimhane iş akışları için özel olarak yapıldı — kabul, aşamalar, tartımlar ve uyum odaklı kayıtlar — genel üretim şablonlarını zorlamaz. Daha hızlı benimsenir ve et işlemenin gerçekten işlediği metrikleri yansıtır.",
      },
    ],
  },
  seoPages: {
    breadcrumb: {
      home: "Ana Sayfa",
    },
    relatedTitle: "İlgili sayfalar",
    slaughterhouse: {
      title: "Kesimhane Yazılımı ve Et İşleme İzleme | SamperLabs",
      description:
        "Kabulden verime izleme, operasyonel görünürlük ve verim analitiği için kesimhane yazılımı. CarniTrack’in et işleme altyapısını nasıl dijitalleştirdiğini keşfedin.",
      h1: "Gerçek işleme hatları için geliştirilmiş kesimhane yazılımı",
      intro:
        "Modern kesimhaneler hâlâ fişler, e-tablolar ve birbirinden kopuk tartılarla çalışıyor. SamperLabs bu parçalanmayı, tesisinizdeki hayvan akışına göre tasarlanmış kesimhane yazılımıyla değiştirir — kabul ve tanımlamadan aşamalara, tartılara ve verime kadar — böylece süpervizörler dünü değil şu anı görür.",
      h2_1: "Bir kesimhanenin neden özel yazılıma ihtiyacı var?",
      p1:
        "Genel araçlar nadiren karkas akışını, sıcak ağırlık yakalamayı veya sınıf ve verimi günlük operasyonlarla örtüşecek şekilde modeller. Amaçlı yazılım, ekranları ve veri modellerini hatlarınızla hizalar; çift girişi azaltır ve personel eğitimini kolaylaştırır. Her adım tek yerde kaydedildiğinde denetimler, kayıtları yeniden kurmak yerine rutin işin yan ürünü olur.",
      h2_2: "Kabul ve tanımlama izlenebilirlik ile kapasiteyi nasıl destekler?",
      p2:
        "Sağlam kabul ve tanımlama günün tonunu belirler. Kesimhane yönetim yazılımı kaydı hızlandırmalı, yanlış etiketi azaltmalı ve her aşağı akış tartı olayına hayvan bağlamalıdır. Canlı panolar darboğazları — hangi aşama tıkanıyor, bekleme süresi nerede yüksek — erken gösterir.",
      h2_3: "Verim analitiği kesimhane operasyonlarını nasıl iyileştirir?",
      p3:
        "Verim, marjın deftere yansıdığı yerdir. Tartı ve sonuçları ayrıntılı izlemek vardiya, tedarikçi ve sezonları karşılaştırmanıza yardım eder. CarniTrack işleme zekâsına odaklanır: yapılandırılmış kayıtlar, trendler ve yönetimin güvenebileceği operasyon metrikleri.",
      h2_4: "CarniTrack nedir ve tesisinize nasıl destek olur?",
      p4:
        "CarniTrack, SamperLabs’in sahne ve idari ekipler için çekirdek ürünüdür — et işleme izleme, uyum odaklı kayıtlar ve analitik için operasyon katmanı. Tarayıcıda çalışır, ekiplerinizin çalışma biçimiyle bütünleşir ve tek tesisten çok tesisli yapıya ölçeklenir.",
      h2_5: "Kesimhane yazılımı değerlendirirken sonraki adımlar nelerdir?",
      p5:
        "Kesimhane yazılımı değerlendiriyorsanız en sürtünmeli adımlarınızla — genelde kabul, tartı veya verim raporlama — başlayın ve verinin nasıl akması gerektiğini haritalayın. Ekibimiz CarniTrack’i iş akışınıza göre anlatabilir ve protein tedarik zincirinde manuel işi azaltan bağlı yaklaşımı gösterebilir.",
      cta: "Demo talep edin",
      ctaHint: "Kabul, tartı ve verimin dijitalleşmesi hakkında konuşalım.",
    },
    livestock: {
      title: "Hayvancılık Yönetim Yazılımı ve Sığır İzleme | SamperLabs",
      description:
        "Üreticileri işleme verisine bağlayan hayvancılık yönetim yazılımı ve sığır izleme. AgriTrack ve çiftlikten tesise SamperLabs katmanını keşfedin.",
      h1: "Çiftlik ile tesisi birleştiren hayvancılık yönetim yazılımı",
      intro:
        "Hayvancılık üreticileri ve işleyiciler sıklıkla farklı sistemlerde çalışır: çiftlikte e-tablolar, kapıda kağıt, tesiste kopuk veritabanları. SamperLabs hayvancılık yönetimini süreklilik sorunu olarak ele alır — aynı hayvanın çiftlikten işlemeye kadar tutarlı kaydı olmalı, her devirde yeniden yazılmamalıdır.",
      h2_1: "Hayvancılık yönetim yazılımı neleri kapsamalıdır?",
      p1:
        "Etkili yazılım; tanımlama, büyüme ve hareket geçmişi ile işleyicinin güvenebileceği devir verisini birleştirir. Üreticiler için hangi partinin ne zaman sevk edildiği belirsizliği azalır. Tesisler için daha temiz kabul ve ağırlık veya menşe sorularında daha az anlaşmazlık demektir.",
      h2_2: "Sığır izlemesi ölçekte nasıl doğru kalır?",
      p2:
        "Etiketler, kağıt ve dağınık dosyalar ayrıldığında sığır izleme çöker. Güncellemelerin ve zaman damgalarının net sahipliğiyle tek doğruluk kaynağı denetimleri ve müşteri sorularını e-posta avından kurtarır. SamperLabs yapılandırılmış veriyi öne çıkarır.",
      h2_3: "AgriTrack nedir ve üreticilere nasıl yardımcı olur?",
      p3:
        "AgriTrack SamperLabs’i tesisten yukarı taşır; işleyicinin verinin nasıl gelmesini beklediğiyle üretici araçlarını hizalar. Amaç kesintisiz sürekliliktir: tesis tarafındaki kesimhane yazılımıyla örtüşen çiftlik bağlamı.",
      h2_4: "Çiftlikler ve işleyiciler ortak metriklerde nasıl hizalanır?",
      p4:
        "Çiftlik ve tesis tanımlayıcılar ve temel olaylar konusunda anlaştığında her iki taraf da her ilişki için özel entegrasyon kurmadan önemli metrikleri ölçebilir. SamperLabs veriyi kopyalamak yerine üzerinde iş birliği yapılabilen bağlı katmanı inşa eder.",
      h2_5: "Çiftlikten tesise izlenebilirlik için nasıl başlarım?",
      p5:
        "Besici işletiyor, entegre ortaklarla çalışıyor veya tesis kabulünü yönetiyor olun; hayvancılık yönetiminin uçtan uca izlenebilirlik için CarniTrack ile nasıl bağlandığını gösterebiliriz. Operasyonunuza özel bir görüşme için iletişime geçin.",
      cta: "Satışla iletişim",
      ctaHint: "Çiftlikten tesise veri ve AgriTrack’i konuşalım.",
    },
    protein: {
      title: "Protein Tedarik Zinciri Platformu | Çiftlikten Çatala Yazılım | SamperLabs",
      description:
        "Çiftlikten çatala görünürlük için protein tedarik zinciri platformu — birleşik işleme yazılımı, yukarı akış hayvan verisi ve et operasyonları analitiği.",
      h1: "Et endüstrisi için protein tedarik zinciri platformu",
      intro:
        "Protein tedarik zinciri çiftlikleri, lojistiği, işlemeyi ve perakendeyi kapsar; yazılım ise sıklıkla her şirketin duvarlarında biter. SamperLabs çiftlikten çatala yazılımını pragmatik şekilde kurar: önce tesisteki operasyonel gerçeği sağlamlaştırın, sonra dışa görünürlük genişletin.",
      h2_1: "Protein tedarik zinciri neden özel bir platforma ihtiyaç duyar?",
      p1:
        "Et ve kümes hayvanları sıkı güvenlik ve etiket beklentileri altında hareket eder. Platform; izlenebilirliği ve operasyon metriklerini aylık dışa aktarım değil günlük iş akışının parçası yapmalıdır. Hayvan, parti ve verimi anlayan modeller gerekir.",
      h2_2: "Tesisler her sistemi değiştirmeden görünürlük nasıl kazanır?",
      p2:
        "Çoğu tesis her sistemi bir gecede değiştirmez. Akıllı platform, ağırlık ve olayların zaten yakalandığı yere zekâ ekler ve yönetim için birleştirir. SamperLabs benimsemeyi önceliklendirir.",
      h2_3: "İşleme zekâsı ve yukarı akış verisi ortakları nasıl bağlar?",
      p3:
        "CarniTrack gerçek zamanlı izleme ve verim analitiğiyle işleme tarafını sabitler. AgriTrack üretici bağlamını öne getirir. Birlikte uyumlu kayıt omurgası oluşturur — uyum, iyileştirme ve iş birliği için.",
      h2_4: "Protein tedarik zinciri analitiği neleri ölçmelidir?",
      p4:
        "Panolar kapasite, verim ve darboğazları operatör dilinde yansıtmalıdır. SamperLabs metrikleri hattaki fiziksel gerçekle bağlar; kadro, tedarikçi performansı ve fireyi görmenize yardım eder.",
      h2_5: "SamperLabs vizyonunu ekibinizle nasıl keşfedebilirsiniz?",
      p5:
        "Protein tedarik zincirinde dijital dönüşümden sorumluysanız SamperLabs’in işleme verisini nasıl birleştirdiğini ve ortak entegrasyon kapısını nasıl açtığını göstermek isteriz. Mevcut ürünler ve yön için demo talep edin.",
      cta: "Demo talep edin",
      ctaHint: "SamperLabs’in işleme ve yukarı akış verisini nasıl bağladığını görün.",
    },
  },
};

export default tr;
